import React from "react";
import "./SponsorsComponent.css";
import PageCover from "../HeaderComponents/PageCover";
import Image from "./ImageComponent/ImageComponent";
import { Fade } from "react-reveal";
import ComingSoon from "../ComingSoonComponent/ComingSoonComponent";
import { Helmet } from "react-helmet";
import "./SponsorsComponent2023.css"

const sponsors = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>TEDxBITD - Our Sponsors</title>
        <meta
          name="description"
          content="TEDx events are known for highlighting innovative ideas & changes through the stage. Sponsoring TEDxBITD will help them grow through the offers provided alongside the opportunity to be a part of something unique."
        />
        <meta
          name="keywords"
          content="ted,tedx,bit,durg,speakers,bitd,event,campus,college,bhilai"
        />
      </Helmet>
      {/* <ComingSoon
        title="Be Our Proud Partners"
        image="sponsors.png"
        button="Partner with Us"
        link="sponsornominations"
      >
        <strong>TEDxBITD</strong> intends to bring a change to the audience with
        amazing speakers sharing their ideas and life stories. We're excited to
        be a TEDx event licensee and we're looking for groups or companies that
        believe in the power of youth events, sharing ideas, and supporting our
        event.
        <br />
        <br />
        <strong>TEDxBITD</strong> would be more than pleased to discuss the ways
        you could be a part of this incredibly new and unique experience. For
        additional information, reach us.
      </ComingSoon> */}
      <PageCover title="Sponsors 2023" />
      <center className="applyBtn">
          <h3>Become our proud sponsors for the 2023 version</h3>
          <div className="inputGroup">
            <a href="/sponsornominations">
              Apply&nbsp;&nbsp;<i className="fas fa-arrow-right"></i>
            </a>
          </div>
        </center>
        <div className="responsive">
          
        <h2 className="sponsor-title open"  style={{width:'80% !important',marginTop:'3rem',marginBottom:'-1rem' ,textAlign:'center'}}>
              <span style={{fontSize:'2.5rem'}}>
                
                <strong>Title </strong> Sponsor
              </span>
            </h2>
       
      <div className="sponsorsCont">
        <div>
          <Fade up>
          
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/jhankarr.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
          
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/jhankarr.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
          
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/jhankarr.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
          
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/jhankarr.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
          </div>
        </div>
        <h2 id="AssociateSponsor"  style={{width:'80% !important',marginTop:'3rem' ,marginBottom:'-1rem',textAlign:'center'}}>
              <span style={{fontSize:'2.5rem'}}>
                
                <strong>Associate </strong> Sponsor
              </span>
            </h2>

            <div className="sponsorsCont">
        <div>
          <Fade up>
          
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/jhankarr.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
          
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/jhankarr.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
          
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/jhankarr.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
          </div>
        </div> 
        
        <h2 id="CoSponsor" className="sponsor-title open"  style={{marginTop:'3rem',marginBottom:'-1rem' ,textAlign:'center'}}>
              <span style={{fontSize:'2.5rem'}}>
                
                <strong>Co </strong> Sponsor
              </span>
            </h2>

            <div className="sponsorsCont">
            <div>
          <Fade up>
          
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/jhankarr.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div>
            <div>
          <Fade up>
          
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/jhankarr.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div>
            <div>
          <Fade up>
          
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/jhankarr.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div>
            </div>
        
            </div>
        {/* <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Title</strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
              <Image
                  path="./assets/images/sponsors/idea-codify.png"
                  title="idea codify"
                />
              </Fade>
            </div>
          </Fade>
        </div> */}
    
        {/* <div>
          <Fade up>
            <h2 className="" style={{display:'block' , background:'white',color:'white'}}>
              <span>
                <strong>Chattisgarh </strong> Shashan
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://cgstate.gov.in/"
                  path="./assets/images/sponsors/1.png"
                  title="Chhattisgarh Shashan"
                />
              </Fade>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
          <h2 className="sponsor-title open" style={{width:'80% !important',lineHeight:'0.2rem',marginTop:'2rem' ,textAlign:'center'}}>
              <span style={{fontSize:'2.5rem'}}>
                
                <strong>Title </strong> Sponsor
              </span>
            </h2>
        
            
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://www.onlinesbi.com/"
                  path="./assets/images/sponsors/sbi.png"
                  title="State Bank of India"
                />
              </Fade>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="" style={{display:'block' , background:'white',color:'white'}}>
              <span>
                .
                
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://fablabs.in/"
                  path="./assets/images/sponsors/Fablabs.png"
                  title="Fablabs.in"
                />
              </Fade>
            </div>
          </Fade>
        </div> */}
   
        {/* <h2 className="sponsor-title open" style={{width:'80% !important',lineHeight:'0.2rem',marginTop:'2rem' ,textAlign:'center'}}>
              <span style={{fontSize:'2.5rem'}}>
                
                <strong>Title </strong> Sponsor
              </span>
            </h2> */}

        {/* <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Technical </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://www.geeksforgeeks.org/"
                  path="./assets/images/sponsors/Geeks-for-Geeks.png"
                  title="Geeks for Geeks"
                />
              </Fade>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Food</strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://www.instagram.com/curriedtheandhrakitchen/"
                  path="./assets/images/sponsors/Curried.png"
                  title="Curried.in"
                />
              </Fade>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Food </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://sandwichjunction.in/"
                  path="./assets/images/sponsors/sandwitchjunction.png"
                  title="Fablabs.in"
                />
              </Fade>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Education </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://fintechedu.in/#/"
                  path="./assets/images/sponsors/Fintech-edu.png"
                  title="Fintech edu"
                />
              </Fade>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Gifting </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://lokabazar.in/"
                  path="./assets/images/sponsors/Lokabazar.png"
                  title="Lokabazar.in"
                />
              </Fade>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Media</strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://www.eatmy.news/"
                  path="./assets/images/sponsors/Eat-my-News.png"
                  title="Eatmynews.in"
                />
              </Fade>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>NGO </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://starlight.org.in/"
                  path="./assets/images/sponsors/Starlight-logo.png"
                  title="Starlight Foundation"
                />
              </Fade>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Outreach </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://www.instagram.com/feevin.in/"
                  path="./assets/images/sponsors/Feevin-media.png"
                  title="Feevin Media"
                />
              </Fade>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Career </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://abclasses.in/"
                  path="./assets/images/sponsors/Ab.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Printing </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/bansal.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Ticketing </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://www.instagram.com/thenomadscafe/"
                  path="./assets/images/sponsors/nomads.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Community </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://www.instagram.com/iamstillhumanofficial/"
                  path="./assets/images/sponsors/human.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Decoration </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://www.instagram.com/welcomedecorators/"
                  path="./assets/images/sponsors/welcome.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div> */}
        {/* <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Sound </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/jhankarr.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div> */}
        {/* <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Screen </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://www.instagram.com/theweddingcorporate/"
                  path="./assets/images/sponsors/wedding.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div> */}
        
     
      
      
    </React.Fragment>
  );
};

export default sponsors;
